'use strict';

var jsonldSignaturesBbs = require('@mattrglobal/jsonld-signatures-bbs');
var w3cContext = require('@trustvc/w3c-context');
var jsonldSignatures = require('jsonld-signatures');
var jsonld = require('jsonld');
var helper = require('./helper');
var types = require('./types');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var jsonldSignatures__default = /*#__PURE__*/_interopDefault(jsonldSignatures);
var jsonld__namespace = /*#__PURE__*/_interopNamespace(jsonld);

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const isRawDocument = /* @__PURE__ */ __name((document) => {
  try {
    helper._checkCredential(document, void 0, "sign");
  } catch (err) {
    return false;
  }
  return typeof document === "object";
}, "isRawDocument");
const isSignedDocument = /* @__PURE__ */ __name((document) => {
  try {
    helper._checkCredential(document, void 0, "verify");
  } catch (err) {
    return false;
  }
  return typeof document === "object" && "proof" in document;
}, "isSignedDocument");
const signCredential = /* @__PURE__ */ __name(async (credential, keyPair, cryptoSuite = "BbsBlsSignature2020", options) => {
  try {
    if (cryptoSuite === "BbsBlsSignature2020") {
      helper._checkKeyPair(keyPair);
      helper._checkCredential(credential, void 0, "sign");
      const documentLoader = options?.documentLoader ?? await w3cContext.getDocumentLoader();
      const key = new jsonldSignaturesBbs.Bls12381G2KeyPair(keyPair);
      credential = helper.prefilCredentialId(credential);
      const signed = await jsonldSignatures__default.default.sign(credential, {
        suite: new jsonldSignaturesBbs.BbsBlsSignature2020({
          key
        }),
        purpose: new jsonldSignatures__default.default.purposes.AssertionProofPurpose(),
        documentLoader
      });
      return {
        signed
      };
    } else {
      return {
        error: `"${cryptoSuite}" is not supported.`
      };
    }
  } catch (err) {
    if (!(err instanceof Error)) {
      return {
        error: "An error occurred while signing the credential."
      };
    }
    const errorMessage = err?.message;
    if (errorMessage.includes("Dereferencing a URL did not result in a valid JSON-LD object")) {
      const errorUrl = err?.details?.url;
      return {
        error: `Dereferencing a URL did not result in a valid JSON-LD object: "${errorUrl || "Unknown URL"}"`
      };
    }
    return {
      error: errorMessage
    };
  }
}, "signCredential");
const verifyCredential = /* @__PURE__ */ __name(async (credential, options) => {
  try {
    helper._checkCredential(credential);
    const documentLoader = options?.documentLoader ?? await w3cContext.getDocumentLoader();
    let verificationResult;
    const proofType = jsonld__namespace.getValues(credential, "proof")[0].type;
    const SuiteClass = types.proofTypeMapping[proofType];
    if (SuiteClass) verificationResult = await jsonldSignatures__default.default.verify(credential, {
      suite: new SuiteClass(),
      purpose: new jsonldSignatures__default.default.purposes.AssertionProofPurpose(),
      documentLoader
    });
    if (verificationResult.verified) {
      return {
        verified: true
      };
    } else if (verificationResult.error && verificationResult.error.errors) {
      const errorMessage = verificationResult.error.errors[0].message;
      if (errorMessage.includes("Unexpected token N in JSON at position 0") || errorMessage.includes("Cannot read properties of undefined (reading 'length')")) {
        return {
          verified: false,
          error: "Verification method could not be found."
        };
      }
      if (errorMessage.includes("Dereferencing a URL did not result in a valid JSON-LD object")) {
        const errorUrl = verificationResult.error.errors[0].details?.url;
        return {
          verified: false,
          error: `Dereferencing a URL did not result in a valid JSON-LD object: "${errorUrl || "Unknown URL"}"`
        };
      }
      return {
        verified: false,
        error: errorMessage
      };
    }
    return {
      verified: false,
      error: "Verification error."
    };
  } catch (err) {
    if (!(err instanceof Error)) {
      return {
        verified: false,
        error: "An error occurred while verifying the credential."
      };
    }
    return {
      verified: false,
      error: err.message
    };
  }
}, "verifyCredential");
const deriveCredential = /* @__PURE__ */ __name(async (credential, revealedAttributes, options) => {
  try {
    helper._checkCredential(credential);
    const documentLoader = options?.documentLoader ?? await w3cContext.getDocumentLoader();
    const derivedProof = await jsonldSignaturesBbs.deriveProof(credential, revealedAttributes, {
      suite: new jsonldSignaturesBbs.BbsBlsSignatureProof2020(),
      documentLoader
    });
    return {
      derived: derivedProof
    };
  } catch (err) {
    if (!(err instanceof Error)) {
      return {
        error: "An error occurred while deriving the proof."
      };
    }
    return {
      error: err.message
    };
  }
}, "deriveCredential");

exports.deriveCredential = deriveCredential;
exports.isRawDocument = isRawDocument;
exports.isSignedDocument = isSignedDocument;
exports.signCredential = signCredential;
exports.verifyCredential = verifyCredential;
